module.exports = __webpack_public_path__ + "assets/pdf/malbec-gran-reserva.4b1fff7d.pdf";